import store from '@/store';
import { DVB_TYPE, SERVICE_TYPE, TV_STATUS } from '.';
import Device from '../Device';

export default class LG {
  static get broadcast() {
    if (b2bapis) return b2bapis.b2bbroadcast;
    if (!window.b2bapis) return undefined;
    return window.b2bapis.b2bbroadcast;
  }

  static get broadcastManager() {
    if (b2bapis) return b2bapis.broadcastManager;
    if (!window.b2bapis) return undefined;
    return window.b2bapis.broadcastManager;
  }

  static get b2bControl() {
    if (b2bapis) return b2bapis.b2bcontrol;
    if (!window.b2bapis) return undefined;
    return window.b2bapis.b2bcontrol;
  }

  static get b2bPower() {
    if (b2bapis) return b2bapis.b2bpower;
    if (!window.b2bapis) return undefined;
    return window.b2bapis.b2bpower;
  }

  static get avPlay() {
    if (!window.webapis) return undefined;
    return window.webapis.avplay;
  }

  static get getListener() {
    return {
      onbufferingstart: function() {
        console.log('buffering start');
        // this.tvStatus = 'buffering start';
      },
      onbufferingprogress: function(percent) {
        console.log('buffering progress..');
        // this.tvStatus = 'buffering progress';
      },
      onbufferingcomplete: function() {
        console.log('buffering complete..');
        // this.tvStatus = 'buffering complete';
      },
      oncurrentplaytime: function(currentTime) {
        //$("#test").prepend("currentTime=="+currentTime);
        // console.log('current playtime :: ' + currentTime);
        // this.tvStatus = 'current playtime :: ' + currentTime;
      },
      onevent: function(eventType, eventData) {
        // $('#test').prepend(
        //   '<p>onevent ' + eventType + ' data ' + eventData + '</p>'
        // );
        // this.tvStatus = 'Event Time: ' + eventType + ', Data: ' + eventData;
        console.log('onevent ' + eventType + ' data ' + eventData);
      },
      onstreamcompleted: function() {
        // $('#test').prepend('<p>stream completed..</p>');
        // this.tvStatus = 'stream completed ...';
        console.log('stream completed..');
      },
      onerror: function(eventType) {
        // this.tvStatus = 'error has occured.. ' + eventType;
        // $('#test').prepend('<p>error has occured..' + eventType + '</p>');
        console.log('error has occured..', eventType);
      },
      onsubtitlechange: function(duration, text, data3, data4) {
        // this.tvStatus = 'subtitle changed..' + duration + text;
        // $('#test').prepend('<p>subtitle changed..</p>');
        console.log('subtitle changed..', duration, text);
      },
      ondrmevent: function(drmEvent, drmData) {
        console.log('on drm event..');
      },
    };
  }

  /*
    hcap.Media.startUp({
      "onSuccess": function () {
          console.log("onSuccess");
          var media = hcap.Media.createMedia({
              "url": "http://media_server_url/media_file.avi",
              "mimeType": "video/mp4",
              "subtitleUrl": "http://media_server_url/media_file.smi"
          });
      },
      "onFailure": function (f) {
          console.log("onFailure : errorMessage = " + f.errorMessage);
      }
    });
  */

  static setChannel(channel, type = SERVICE_TYPE.RADIO, isNew) {
    if (!hcap) {
      console.log(' -- [ERROR]: Missing HCAP');
      return;
    }

    //console.log('TV.setChannel', channel);
    if (type === SERVICE_TYPE.TV) this.handleTVChannel(channel);
    if (type === SERVICE_TYPE.INFO) this.handleTVChannel(channel);
    if (type === SERVICE_TYPE.RADIO) this.handleRadioChannel(channel);
  }

  static clearChannel() {
    //console.log("===========IP-clearChannel===========");
    try {
      hcap.channel.stopCurrentChannel({
        "onSuccess": function () {
            console.log("onSuccess");
        },
        "onFailure": function (f) {
            console.log("onFailure : errorMessage = " + f.errorMessage);
        }
      });
      hcap.Media.shutDown({
        "onSuccess": function () {
            console.log("onSuccess");
        },
        "onFailure": function (f) {
            console.log("onFailure : errorMessage = " + f.errorMessage);
        }
      });
      //this.avPlay.stop();
      //this.avPlay.close();
      //Device.apis.tvwindow.hide(this.callbackSuccess, this.callbackError);
    } catch (e) {
      console.log('could not close');
    }
    return Promise.resolve();
  }

  static clearChannelDVB() {
    const channel_params = {
      "dvb_type": "c",
      "url": "",
      "name": "",
      "serviceId": 0,
      "buildingId": 0,
      "originalNetworkId": 0,
      "transportStreamId": 0,
      "gateway_id": "",
      "serviceType": "tv",
      "position": 0,
      "price": "0.00",
      "frequency": "300000000",
      "symbolRate": "0",
      "tags": [],
      "frequencyInKhz": "300000",
      "packages": [
          "tv-#1"
      ],
      "epgChannelId": 0,
      "id": ""
    };

    try {
      //console.log('===========DVB-clearChannelDVB-TRY===========channel_params=>', channel_params);
      /*this.broadcast.tuneDirect(
        tuneOptions,
        this.callbackSuccess,
        this.callbackError
      );*/
      hcap.channel.stopCurrentChannel({
        "onSuccess": function () {
            console.log("onSuccess");
        },
        "onFailure": function (f) {
            console.log("onFailure : errorMessage = " + f.errorMessage);
        }
      });
      //Device.apis.tvwindow.hide(this.callbackSuccess, this.callbackError);
      this.tuneChannel_DVB(channel_params);
    } catch (error) {
      console.log('could not close DVB');
      store.dispatch('notification/error', {
        title: 'Tune Direct zero',
        message: error,
      });
    }
    return Promise.resolve();
  }
  
  static removePlayer(channel) {
    //store.dispatch('notification/new', {
    //  title: 'REMOVE CHANNEL',
    //  message: 'Channel-Typ: '.channel.dvb_type,
    //});
    //console.log("===========removePlayer===========channel=>", channel);
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        store.dispatch('notification/new', {
          title: 'REMOVE CHANNEL IP',
          message: channel,
        });
        this.clearChannel();
        break;
      case DVB_TYPE.T:
      case DVB_TYPE.C:
      case DVB_TYPE.S:
        store.dispatch('notification/new', {
          title: 'REMOVE CHANNEL DVB',
          message: channel,
        });
        this.clearChannel();
        //this.clearChannelDVB();
        break;
      default:
        //console.log("===========removePlayer-DEDAULT===========channel=>", channel);
        store.dispatch('notification/new', {
          title: 'REMOVE CHANNEL IP/DVB',
          message: channel,
        });
        this.clearChannel();
        this.clearChannelDVB(channel);
    }
    
    //this.clearChannel();
    //this.clearChannelDVB(channel);
  }

  static handleTVChannel(channel) {
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        this.tuneChannel_IP(channel);
        break;
      case DVB_TYPE.T:
      case DVB_TYPE.C:
      case DVB_TYPE.S:
        this.tuneChannel_DVB(channel);
        store.dispatch('notification/new', { title: 'Tune Direct Channel' });
        break;
      default:
        console.log('CHANNEL TYPE NOT SUPPORTED');
    }
  }

  static handleRadioChannel(channel) {
    switch (channel.dvb_type) {
      case DVB_TYPE.IP:
        this.tuneChannel_IP(channel);
        break;
      case DVB_TYPE.T:
      case DVB_TYPE.C:
      case DVB_TYPE.S:
        this.tuneChannel_DVB(channel);
        store.dispatch('notification/new', { title: 'Tune Direct Channel' });
        break;
      default:
        console.log('CHANNEL TYPE NOT SUPPORTED');
    }
  }

  static async tuneChannel_IP(data) {
    this.clearChannel();
    //console.log("======================TUNE", data);
    
    /*const channel = {
      ...data,
      url: data.url.replace('igmp://', 'udp://'),
    };*/

    //console.log('=================================IPmediaPlay IP:', ip);
    //console.log('=================================IPmediaPlay PORT:', port);
    var param = {
      "channelType": hcap.channel.ChannelType.IP,
      "ip": data.url.split('/')[2].split(':')[0],
      "port": parseInt(data.url.split('/')[2].split(':')[1]),
      "ipBroadcastType": hcap.channel.IpBroadcastType.UDP,
      "onSuccess": function () {
        store.dispatch('radio/setStatus', TV_STATUS.LOADED);
        //return Promise.resolve();
      },
      "onFailure": function (f) {
      }
    };

    try {
      hcap.channel.requestChangeCurrentChannel(param);
      //store.dispatch('radio/setStatus', TV_STATUS.LOADING);
      store.dispatch('radio/setStatus', TV_STATUS.LOADING);
    } catch (e) {
      console.log(' -- [ERROR]: while selecting channel: ', e);
      store.dispatch('notification/error', {
        title: 'TuneChannel - IP',
        message: 'Could not tune IP Channel',
      });
    }
    return Promise.resolve();
  }

  static tuneChannel_DVB(channel) {
    //this.clearChannelDVB();
    this.clearChannel();

    var tuneoptions = {};

    switch (channel.dvb_type) {
      case DVB_TYPE.C:
        //tuneOptions.modulationType = channel.modulationType || 'QAM256';
        //tuneOptions.bandwidth = channel.bandwidth || '8Mhz';
        tuneoptions = {
          "channelType": hcap.channel.ChannelType.RF,//1
          "rfBroadcastType": hcap.channel.RfBroadcastType.CABLE,
          "frequency": parseInt(channel.frequency),
          "programNumber": parseInt(channel.serviceId),
        }
        break;
      case DVB_TYPE.T:
        //tuneOptions.modulationType = channel.modulationType || '8PSK';
        //tuneOptions.bandwidth = channel.bandwidth || '8Mhz';
        tuneoptions = {
          "channelType": hcap.channel.ChannelType.RF,//1
          "rfBroadcastType": hcap.channel.RfBroadcastType.TERRESTRIAL_2,//TERRESTRIAL
          "frequency": parseInt(channel.frequency),
          "programNumber": parseInt(channel.serviceId),
        }
        break;
      case DVB_TYPE.S:
        //tuneOptions.modulationType = channel.modulationType || 'QPSK';
        //tuneOptions.bandwidth = channel.bandwidth || '8Mhz';
        var polarization = '';
        if(channel.polarization && channel.polarization === 'VERTICAL') polarization = hcap.channel.Polarization.VERTICAL; else polarization = hcap.channel.Polarization.HORIZONTAL;
        tuneoptions = {
          "channelType": hcap.channel.ChannelType.RF,//1
          "rfBroadcastType": hcap.channel.RfBroadcastType.SATELLITE_2,
          "frequency": parseInt(channel.frequency / 1000000),
          "programNumber": parseInt(channel.serviceId),
          "symbolRate" : parseInt(channel.symbolRate) || parseInt('22000'),
          "satelliteId": channel.satelliteId || parseInt('1'),
          "polarization": polarization,
        }
        break;
    }
      
    var param = {
      ...tuneoptions,
      "onSuccess": function (s) {
        console.log("===SUCCESS=============================TV", s);
      },
      "onFailure": function (f) {
        console.log("===ERROR===============================TV", f);
      }
    };

    try {
      console.log(' -- [TUNE OPTIONS]: ', param, channel);
      hcap.channel.requestChangeCurrentChannel(param);
    } catch (error) {
      console.log(' -- [ERROR]: Could not tune direct');
      store.dispatch('notification/error', {
        title: 'Tune Direct',
        message: error,
      });
    }
  }

  /*
  hcap.Media.startUp({
      "onSuccess": function () {
          console.log("onSuccess");
          var media = hcap.Media.createMedia({
              "url": "http://media_server_url/media_file.avi",
              "mimeType": "video/mp4"
          });
          media.play({
              "onSuccess": function () {
                  console.log("onSuccess");
                  media.stop({
                      "onSuccess": function () {
                          console.log("onSuccess");
                          media.destroy({
                              "onSuccess": function () {
                                  console.log("onSuccess");
                                  hcap.Media.shutDown({
                                      "onSuccess": function () {
                                          console.log("onSuccess");
                                      },
                                      "onFailure": function (f) {
                                          console.log("onFailure : errorMessage = " + f.errorMessage);
                                      }
                                  });
                              },
                              "onFailure": function (f) {
                                  console.log("onFailure : errorMessage = " + f.errorMessage);
                              }
                          });
                      },
                      "onFailure": function (f) {
                          console.log("onFailure : errorMessage = " + f.errorMessage);
                      }
                  });
              },
              "onFailure": function (f) {
                  console.log("onFailure : errorMessage = " + f.errorMessage);
              }
          });
      },
      "onFailure": function (f) {
          console.log("onFailure : errorMessage = " + f.errorMessage);
      }
  });
  */

  static get streamInfo() {
    try {
      const info = this.avPlay.getCurrentStreamInfo();
      return info;
    } catch (e) {
      console.log('ERROR: Could not receive any informations from stream: ', e);
    }
    return [];
  }

  static callbackSuccess(name, context) {
    console.log('CALLBACK_SUCCESS: ', name, ' with context: ', context);
  }
  static callbackError(name, context) {
    console.log('CALLBACK_ERROR: ', name, ' with context: ', context);
  }
  static callbackChange(val) {
    console.log('changed function.' + JSON.stringify(val));
  }

  static PowerState() {
    try {
      const PowerState = this.b2bPower.getPowerState();
      // console.log('[getPowerState] call syncFunction type: ' + PowerState);
      store.dispatch('notification/new', {
        title: 'Power State',
        message: PowerState,
      });
    } catch (e) {
      store.dispatch('notification/new', {
        title: e.name,
        message: e.message,
      });
      console.log(
        '[getPowerState] call syncFunction exception [' +
          e.code +
          '] name: ' +
          e.name +
          ' message: ' +
          e.message
      );
    }
  }

  static turnOff() {
    const cbSuccess = () => this.callbackSuccess('turnOff');
    const cbError = () => this.callbackError('turnOff');
    //this.b2bControl.setPowerOff(cbSuccess, cbError);
    hcap.power.powerOff({
      "onSuccess": function () {
          console.log("onSuccess: turnOff");
      },
      "onFailure": function (f) {
          console.log("onFailure turnOff: errorMessage = " + f.errorMessage);
      }
    });
  }
  static turnOn() {
    const cbSuccess = () => this.callbackSuccess('turnOn');
    const cbError = (err) => this.callbackError('turnOn', err);
    // this.PowerState();
    // console.log('STATE: ', this.PowerState());
    //this.b2bPower.setPowerOn(cbSuccess, cbError);
    hcap.power.setPowerMode({
      "mode": hcap.power.PowerMode.NORMAL,
      "onSuccess": function () {
          console.log("onSuccess turnOn");
      },
      "onFailure": function (f) {
          console.log("onFailure turnOn: errorMessage = " + f.errorMessage);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/RADIO/LG.js